import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';

export function sortTableReducer(state = initialState.sortTable, action) {
	switch (action.type) {
		case types.SAVE_SORT_TABLE:
			return {
				...state,
				[action.data.tab]: {
					columnSort: action.data.columnSort,
					sortDirection: action.data.sortDirection
				}
			};
		case types.SAVE_SORT_TABLE_ALL:
			return action.data;
		default:
			return state;
	}
}
